import React, { useState, Fragment, forwardRef } from 'react'
import AddressFormComponent from './address-form'

const AddressHistory = forwardRef(
  (
    {
      lookup,
      label,
      name,
      minimumRequiredYears = 3,
      error,
      formVariant,
      defaultValue = [{}],
      handleTrackInteraction,
    },
    ref,
  ) => {
    const [addresses, setAddresses] = useState(defaultValue)

    const updateAddresses = (addresses, updatedAddressKey, updatedAddress) => {
      return addresses.map((address, index) => {
        if (index === updatedAddressKey) {
          return { ...address, ...updatedAddress }
        }
        return address
      })
    }

    const filterAddresses = (addresses, minimumRequiredYears) => {
      const recentAddressYears = parseInt(addresses[0].yearsAtAddress || '0', 10)
      const secondAddressYears = parseInt(addresses[1]?.yearsAtAddress || '0', 10)
      const totalFirstTwoAddressesYears = recentAddressYears + secondAddressYears

      if (recentAddressYears >= minimumRequiredYears) {
        return [addresses[0]]
      }

      if (totalFirstTwoAddressesYears >= minimumRequiredYears) {
        return addresses.slice(0, 2)
      }

      return addresses
    }

    const checkNextAddressNeeded = (addresses, minimumRequiredYears) => {
      const totalYearsAtAddresses = addresses.reduce(
        (total, address) => total + parseInt(address.yearsAtAddress || '0', 10),
        0,
      )

      const isLastAddressFilled =
        parseInt(addresses[addresses.length - 1].yearsAtAddress || '0', 10) > 0

      return (
        isLastAddressFilled &&
        totalYearsAtAddresses > 0 &&
        totalYearsAtAddresses < minimumRequiredYears
      )
    }

    const handleAddressSectionChange = (updatedAddressKey, updatedAddress) => {
      handleTrackInteraction({ target: { name } })

      setAddresses((currentAddresses) => {
        const updatedAddresses = updateAddresses(
          currentAddresses,
          updatedAddressKey,
          updatedAddress,
        )

        const filteredAddresses = filterAddresses(updatedAddresses, minimumRequiredYears)
        const shouldAddNextAddress = checkNextAddressNeeded(updatedAddresses, minimumRequiredYears)
        return shouldAddNextAddress ? [...filteredAddresses, {}] : filteredAddresses
      })
    }

    return (
      <Fragment>
        <input
          type='hidden'
          id='addressData'
          name={name}
          ref={ref}
          value={JSON.stringify(addresses)}
        />
        {addresses.map((_, index) => (
          <AddressFormComponent
            key={index}
            label={label}
            addressIndex={index}
            lookup={lookup}
            onChange={handleAddressSectionChange}
            error={error}
            formVariant={formVariant}
            defaultValue={addresses[index]}
            minimumRequiredYears={minimumRequiredYears}
          />
        ))}
      </Fragment>
    )
  },
)

export default AddressHistory
